/**
 * action types
 */
export const INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_START =
  'INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_START';
export const INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_SUCCESS =
  'INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_SUCCESS';
export const INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_FAILURE =
  'INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_FAILURE';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE';
